module.exports = __webpack_public_path__ + "img/healthcare.57027c24.svg";